import { formatRangeLabel } from "../../utils/dateRange";

const DateRangeAppliedLabel = ({
  from = "",
  to = "",
  prefix = "Date range: ",
  emptyLabel = "All dates",
  className = "",
}) => (
  <span className={`inline-flex h-11 items-center text-sm leading-none text-gray-600 ${className}`}>
    {prefix ? <span>{prefix}</span> : null}
    <span className="font-UbuntuMedium text-gray-800">
      {formatRangeLabel(from, to, { emptyLabel })}
    </span>
  </span>
);

export default DateRangeAppliedLabel;
